import React, {useEffect, useState} from "react";
import queryString from 'query-string';
import dayjs from 'dayjs';
import {DescriptionText, FlexContainer, H1Text, H2Text, Spinner} from "../../design";
import {Col, Row} from "react-awesome-styled-grid";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
    addInventoryOrderChargeById,
    BASE_URLS,
    declinePaymentLinkByGid,
    getCheckoutCardCharges,
    getCheckoutReconnection,
    getInventoryOrderById,
    getQrPaymentReconnection,
    getSecretValuesById,
    getServerEncription,
    generateClientKeyPair,
    encryptData,
} from "../../api";
import {
    MESSAGES,
    NETBANKING_LIST,
    QR_STATUSES,
    REFRENCE_ID_LENGTH,
    SESSION_TIME,
    SWIREPAY_URL,
    TabNames,
    TANGEDCO_PG,
    WOOCOMMERCE_ORDER_STATUSES,
} from "../../appconstants";
import {AmountDivideByHundred} from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import SmallScreenFooter from "../../components/footer";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import UpiPayment from "../../components/UpiCheckout/UpiCheckout";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import GooglePay from "../../components/googlePay/GooglePay";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg"
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import ApplePay from "../../components/applePay/ApplePay";
import RecaptchaModal from "../../components/recaptcha";
import Apple from '../../routes/apple';
import SavedPaymentMethods from "../../components/SavedPaymentMethods";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import { setFormData } from "../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import PaymentExpandableRows from "../../components/paymentExpandableRows";

type Props = {
    history: {
        push: Function,
    },
}

const InventoryOrder = (props: Props) => {

    const {match: {params: {inventoryorderId}}, location: {pathname, search}} = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${inventoryorderId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [convenience, setConvenience] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(null);
    const [userType, setUserType] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [supportPhoneNumber, setSupportPhoneNumber] = useState(null);
    const [upiError, setUpiError] = useState('');
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [applePayment, setApplePayment] = useState(false);
    const [ipAddress, setIpAddress] = useState('');
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [shippingAddress, setShippingAddress] = useState(null)
    const [isApplePay, setIsApplePay] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
        const [paymentLinkGlobalRecaptcha, setPaymentLinkGlobalRecaptcha] = useState(null);
    const accountGid = [
      'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${inventoryorderId}`) || undefined);
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const dispatch = useDispatch();

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    useState(() => {
        if (window.ApplePaySession) {
          setIsApplePay(true);
        }
      }, []);

    useEffect(() => {
        const parsed = queryString.parse(search);
        const shopTable = parsed.tableGid;
        const slug = parsed.slugName;
        if (search && !shopTable && !slug) {
            getInventoryDataWithSearchValue();
        } else {
            getInventoryDataWithoutSearchValue();
        }
        if (shopTable && slug) {
            localStorage.setItem('shopTable', shopTable);
            localStorage.setItem('slugName', slug);
        }
    }, [inventoryorderId, search]);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
      if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
          if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
              setPayment((prev) => ({...prev, customer: { ...prev.customer, name: updateCustomerRedux.customerDetails.name } }));
          };
          if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
              setPayment((prev) => ({...prev, customer: { ...prev.customer, email: updateCustomerRedux.customerDetails.email } }));
          };
          if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
              && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
          ) {
              setPayment((prev) => ({...prev, customer: { ...prev.customer, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber } }));
          };
          dispatch(setUpdateStatus(false));
      };
    }, [updateCustomerRedux]);

    useEffect(() => {
        if (payment && payment.account.currency && payment.inventoryOrder.total) {
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name)}`);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name));
        }
        //alert(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'))
        setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
        setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US') );
        setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
        // setPaymentTypeOrder([{ category: 'CARD' }]);
        // if(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US') && getCustomerGidFromPayment(payment)) setPaymentTypeOrder([{ category: 'CARD' },{ category: 'WALLET' }]);
        if (payment && payment.account && payment.account.gid) {
            setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
            if (TANGEDCO_PG === payment.account.gid) {
                if (payment.account.paymentTypeOrder) {
                    setPaymentTypeOrder([{ category: 'CARD' }]);
                } else setSupportedPaymentTypes(['CARD']);
                setUpiError('UPI/QR is temporarily down');
            } else if (TANGEDCO_PG !== payment.account.gid) {
                if (payment.account.paymentTypeOrder) {
                    const paymentMethod = getUniquePaymentTypes(payment?.paymentMethodType?.length > 0 ? payment?.paymentMethodType : payment?.account?.supportedPaymentTypes);
                    const paymentOrders = payment && payment?.account && payment?.account?.paymentTypeOrder;
                    const filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
                    let newfilterPaymentOrder;
                    if (!paymentOrders.includes('GOOGLE_PAY_US')) {
                        newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
                        setPaymentTypeOrder(newfilterPaymentOrder);
                    } else {
                        setPaymentTypeOrder(filterPaymentOrder);
                    }
                } else {
                    setSupportedPaymentTypes(payment && payment.paymentMethodType);
                }
            }
        }
        setSupportPhoneNumber(payment && payment.support && payment.support.phone);
    }, [payment]);

    useEffect(() => {
        setErrorMessage(null);
        if (payment && payment.account.currency && payment.inventoryOrder.total) {
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name)}`);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name));
        }
        setConvenience(0);
        setGst(0);
    }, [selectedTab]);

    const getGooglePayMerchantValues = async (accountGid, isTest) => {
        try {
            const values = await getSecretValuesById(accountGid, isTest);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support')
        }
    };

    const getInventoryDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getInventoryOrderById(inventoryorderId, search);
            if (value) {
                const {returnUrl, status} = value;
                const timeOut = returnUrl ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (WOOCOMMERCE_ORDER_STATUSES.CREATED !== status) {
                    setTransactionSuccessModalOpen(true);
                    setTimeout(function () {
                        const redirectUrl = returnUrl ? returnUrl : SWIREPAY_URL;
                        window.location = redirectUrl;
                    }, 10000);
                }
            }
        } catch (reason) {
            try {
                const value = await getInventoryOrderById(inventoryorderId, null);
                if (value) {
                    setPayment(value);
                    setUserType(value.account && value.account.mdr);
                    if (value.account && value.account.portal) {
                        const portal = value.account.portal.test;
                        setIsTest(portal);
                        setBankImageUrl(value.account && value.account.bankImageUrl);
                        setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                        supportedBankTypes(value.account.supportedPaymentTypes);
                        if (portal) {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                            setBanksList(supportedBanks);
                        } else {
                            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                            setBanksList(supportedBanks);
                        }
                    }
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        if (!reason) return;
        const {data: {message, messageCode}, status} = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) {
                errorEl.scrollIntoView();
            }
        }
    };

    const getPaymentCharges = async (cardNumber, payments) => {
        setPayment(payments);
        try {
            const value = await getCheckoutCardCharges(inventoryorderId, cardNumber);
            if (value) {
                setConvenience(currencyFormatter(AmountDivideByHundred(value.feeAmount)));
                setGst(currencyFormatter(AmountDivideByHundred(value.taxAmount)));
                setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name)}`)
                setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name));
            }
        } catch (e) {
            setConvenience(0);
            setGst(0);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency.name));
        } finally {
            setShowSpinner(false)
        }
    }

    const getInventoryDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getInventoryOrderById(inventoryorderId, null);
            if (value) {
                const {redirectUri} = value;
                // if (WOOCOMMERCE_ORDER_STATUSES.CREATED !== value.inventoryOrder.status) {
                //     if(value && value.redirectUrl){
                //         window.location = value.redirectUrl;
                //     }else{
                //     props.history.push(`${pathname}/expired`);
                //     return;
                //     }
                // }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                setPayment(value);
                dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                  value: {
                    phoneNumber: getCountryCodeAndNumber(value?.inventoryOrder?.customer?.phoneNumber)?.phoneNumber,
                    countryCode: getCountryCodeAndNumber(value?.inventoryOrder?.customer?.phoneNumber)?.countryCode || '+1',
                    name: value?.inventoryOrder?.customer?.name,
                    email: value?.inventoryOrder?.customer?.email,
                    disablePhone: !!value?.inventoryOrder?.customer?.phoneNumber,
                    disableEmail: !!value?.inventoryOrder?.customer?.email,
                    disableName: !!value?.inventoryOrder?.customer?.name,
                  } 
                }));
                setShippingAddress(
                    value &&
                    value.inventoryOrder &&
                    value.inventoryOrder.customer &&
                    value.inventoryOrder.customer.shippingAddress
                );
                if (value.account && value.account.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    setBankImageUrl(value.account && value.account.bankImageUrl);
                    setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                    if (portal) {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                        setBanksList(supportedBanks);
                    } else {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                        setBanksList(supportedBanks);
                    }
                }
                
                console.log(value)
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US')) {
                   
                    getGooglePayMerchantValues(value && value.account && value.account.gid, value?.account?.portal?.test);
                }
                if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('APPLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && !swirepayUS && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid, value?.account?.portal?.test);
                }
                setUserType(value.account && value.account.mdr);
            }
        } catch (e) {
            console.log('ERROR : ', e)
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment && payment.inventoryOrder && payment.inventoryOrder.customer && payment.inventoryOrder.customer.gid;
    };

    const chargeByNetBanking = async (data) => {
        const {gid} = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await addCheckoutPageById({paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment)});
    };


    const chargeByUpi = async (data) => {
        const {paymentMethod} = data;
        await addCheckoutPageById({
            "paymentMethod": paymentMethod
        });
    };

    const chargeByAch = async (data) => {
        const {customer, paymentMethod} = data;
        await addCheckoutPageById({customer, paymentMethod, customerGid: getCustomerGidFromPayment(payment)});
    };

    const chargeByInstantPay = async (data) => {
        const {walletAlias} = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await addCheckoutPageById({paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment)});
    };

    const chargeBySwirepayUS = async (data) => {
        const {walletAlias} = data;
        const paymentMethod = {
            type:"WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await addCheckoutPageById({paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment)});
    };

    const chargeByCard = async (data) => {
        const {paymentMethod, customer, notify} = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        if (customer.Address) {
            //alert(JSON.stringify(customer.Address))
            delete customer.Address;
        }
        /* if(shippingAddress){
             //alert("abc"+JSON.stringify(shippingAddress))
         delete shippingAddress.country;
         shippingAddress.countryCode = "US";
         customer.shippingAddress = shippingAddress ;}*/
        await addCheckoutPageById({paymentMethod, customer, shouldWhatsAppNotify: notify});
    };

  const chargeBySavedPaymentMethods = async (data) => {
    const customerGid = getCustomerGidFromPayment(payment);
    const userAgent = {
        acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
        ip: ipAddress,
        language: window.navigator.language,
        colorDepth: window.screen.colorDepth,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        timeZone: new Date().getTimezoneOffset(),
        browserUserAgent: window.navigator.userAgent
    };
    await addCheckoutPageById({ paymentMethod: { ...data, customerGid, userAgent }, recaptchaToken: data.recaptchaToken, platformType: 'WEB' });
  };

    const chargeByBank = async (data) => {
        const {customer, fundingSourceId} = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await addCheckoutPageById({
            customer,
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment)
        });
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        await addCheckoutPageById({paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment)});
    };


    const chargeByApple = async (paymentData) => {
        const {
            deviceData,
            // amount,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };
        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }
        let customer = {
            email: customerEmail,
            name: customerName,
            phoneNumber: customerPhone
        }
        await addCheckoutPageById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            customer: customer
        });

    }

    const chargeByCardpointeApplePay = async (paymentData) => {
        const {
            deviceData,
            // amount,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
      
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };

        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }

        let customer = {
            email: customerEmail,
            name: customerName,
            phoneNumber: customerPhone,
        }

        await addCheckoutPageById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            customer: customer
        }, null);
    };

    const chargeByApplePay = async (stripePaymentMethod) => {
        // const meta = stripePaymentMethod;
        const paymentMethod = {
            applePayUS: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: stripePaymentMethod.billing_details.name,
                email: stripePaymentMethod.billing_details.email,
                phone: stripePaymentMethod.billing_details.phone
            },
            customerGid: getCustomerGidFromPayment(payment),
            type: "WALLET",
            subType: "APPLE_PAY_US",
            rawData: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: stripePaymentMethod.name,
                email: stripePaymentMethod.email,
                phone: stripePaymentMethod.phone
            }
        };
        await addCheckoutPageById({paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment)});
    };


    const addCheckoutPageById = async (data, recaptchaToken = null) => {
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await addInventoryOrderChargeById(inventoryorderId, payload);
                        if (value) {
                            // const { nextActionUrl, redirectUrl } = value;
                            let nextActionUrl;
                            let redirectUrl;
                            let returnUrl;
                            if (value && value.paymentSession) {
                                nextActionUrl = value.paymentSession && value.paymentSession.nextActionUrl ? value.paymentSession.nextActionUrl : value.nextActionUrl;
                                redirectUrl = value.paymentSession && value.paymentSession.redirectUrl ? value.paymentSession.redirectUrl : value.redirectUrl;
                                returnUrl = value.paymentSession && value.paymentSession.returnUrl;
                            } else {
                                const info = await getInventoryOrderById(inventoryorderId, null);
                                nextActionUrl = info && info.paymentSession && info.paymentSession.nextActionUrl;
                                redirectUrl = value && value.redirectUrl;
                            }
                            if (nextActionUrl) {
                                window.location = nextActionUrl;
                                return;
                            }
                            setTransactionModalOpen(false);
                            setTransactionSuccessModalOpen(true);
                            setTimeout(function () {
                                const redirectUri = returnUrl ? returnUrl : redirectUrl ? redirectUrl : SWIREPAY_URL;
                                window.location = redirectUri;
                                sessionStorage.removeItem("stripeRes");
                            }, 10000);
                            if (inventoryorderId) {
                                localStorage.removeItem(`${inventoryorderId}-tap-index`)
                            }
                        }
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429){
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
            case TabNames.UPI:
            case TabNames.INSTANT_PAYMENT:
                setPaymentLinkGlobalRecaptcha(token);
                break;
            default:
                await addCheckoutPageById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    }

    const getCheckoutById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getCheckoutReconnection(paymentSession, psClientSecret);
            if (value) {
                const {status} = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-checkout-page=${inventoryorderId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-checkout-page=${inventoryorderId}`;
                        }
                    }, timeOut);
                    if (inventoryorderId) {
                        localStorage.removeItem(`${inventoryorderId}-tap-index`)
                    }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
            if (value) {
                const {status} = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-checkout-page=${inventoryorderId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-checkout-page=${inventoryorderId}`;
                        }
                    }, timeOut);
                    if (inventoryorderId) {
                        localStorage.removeItem(`${inventoryorderId}-tap-index`)
                    }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const cancelAlertOpen = () => {
        setAlertConfig({
            showIcon: true,
            isOpen: true,
            hideBtn: false,
            cancel: resetAlertConfig,
            header: "Are you sure!",
            body: "You will not be able to recover this payment link",
            submitBtnText: "Yes, decline it!",
            cancelBtnText: "Cancel",
            showCancelBtn: true,
            showSubmitBtn: true,
            submit: declinePaymentLink,
            icon: WARNING_ICON
        });
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const declinePaymentLink = () => {
        setAlertConfig({
            ...defaultAlertConfig,
            showIcon: true,
            isOpen: true,
            hideBtn: true,
            header: `Please Wait!. Your payment link decline is being processed`,
            body: "You will be redirected when the decline is successful.",
        });
        if (payment && payment.gid) {
            declinePaymentLinkByGid(payment.gid).then(value => {
                if (value) {
                    const {redirectUri} = value;
                    const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                    setAlertConfig({
                        ...defaultAlertConfig,
                        showIcon: true, isOpen: true, hideBtn: true,
                        header: "PaymentLink Decline Completed", body: "You will be redirected automatically.",
                        icon: SUCCESS_ICON
                    });
                    setTimeout(function () {
                        const redirectUrl = redirectUri || SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        const decline = "decline=true";
                        if (urlPath) {
                            window.location = `${redirectUrl}&${decline}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?${decline}`;
                        }
                    }, timeOut);
                }
            }).catch(reason => error(reason));
        }
    };

    const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    //alert(JSON.stringify(uniquePaymentTypes));
    if(uniquePaymentTypes.includes('WALLET')) {
        if (swirepayUS) {
            uniquePaymentTypes.push('SWIREPAY_US');
        }
        if (!googlePayUs) {
            const index = uniquePaymentTypes.indexOf('WALLET');
            if (index > -1) {
                uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
            }
        } 
    }
    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                customerDisabled={false}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                // isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={inventoryorderId}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                hideCustomer={false}
                // showBillDetails={true}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                customerValidation={true}
                // charges={true}
                // convenience={convenience}
                // gst={gst}
                prefix={payment && payment.account.currency && payment.account.currency.prefix}
                billAmountApple={AmountDivideByHundred(payment && payment.inventoryOrder.total)}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.inventoryOrder.total), payment && payment.account.currency && payment.account.currency.name)}`}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                totalAmount={totalAmount}
                userType={userType}
                payments={payment && payment}
                ApplePayment={applePayment}
                payment={payment}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                showWhatsAppNotify={true}
            />
            id = name;
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
            id = name;
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                chargeByGooglePay={chargeByGooglePay}
                errorMsg={errorMessage}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorHeader={null}
                payment={payment}
            />
            id = name;
        } else if (name === TabNames.WALLET) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
            id = name;
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                headerText={"PAY WITH WALLET Alias"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.INVENTORY_ORDER_CHARAGE}/${inventoryorderId}`}
                buttonText={submitBtnText}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else if (name === TabNames.SWIREPAY_US) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                headerText={"PAY WITH WALLET Alias"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeBySwirepayUS}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.INVENTORY_ORDER_CHARAGE}/${inventoryorderId}`}
                buttonText={submitBtnText}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                swirepayUS={swirepayUS}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({children, id});
        return panel;
    }, []) : [
        {
            children: <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                hideCustomer={false}
                // showBillDetails={true}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment && payment.inventoryOrder && payment.inventoryOrder.customer}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                customerValidation={true}
                // charges={true}
                // convenience={convenience}
                // gst={gst}
                prefix={payment && payment.account.currency && payment.account.currency.prefix}
                billAmountApple={AmountDivideByHundred(payment && payment.inventoryOrder.total)}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.inventoryOrder.total), payment && payment.account.currency && payment.account.currency.name)}`}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                totalAmount={totalAmount}
                userType={userType}
                payments={payment && payment}
                ApplePayment={applePayment}
                payment={payment}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                showWhatsAppNotify={true}
            />,
            id: 'CARD'
        }
       
        
    ]

    const tabPanelsApple = { //children :  <Apple amount={AmountDivideByHundred(payment && payment.inventoryOrder.total)} chargeByApple={chargeByApple} payment={payment}/>
              children : applePayment&&isApplePay ? <Apple amount={payment && payment.inventoryOrder.total} chargeByApple={chargeByCardpointeApplePay} payment={payment}/>:null  
            };
    tabPanels.push(tabPanelsApple);

    if (payment?.account?.country?.alpha2 === 'US') {
      tabPanels.push({
          children: <SavedPaymentMethods
                      buttonText={`${currencyFormatter(AmountDivideByHundred(payment && payment.inventoryOrder.total), payment && payment.account.currency && payment.account.currency.name)}` || submitBtnText}
                      submit={chargeBySavedPaymentMethods}
                      supportedPaymentTypes={uniquePaymentTypes}
                      accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                  />,
          id: 'SAVED_PAYMENT_METHODS'
      });
    }

   

    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;

    return (
        <BaseSplitPage
        errorHeader={null}
        errorMsg={errorMessage}
        left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{width: "125px"}} alt=""/>
                            )
                        }
                        <H1Text>
                            Payment Checkout
                        </H1Text>
                        <div className="mb-2" style={{fontWeight: '400', fontSize: '14px', color: '#909090'}}>
                            Payment For
                        </div>
                        <Row>
                            <Col className="mt-2"
                                 style={{fontWeight: '600', fontSize: '18px', marginLeft: "0px", color: '#1B1B1B'}}>
                                {(payment && payment.description) || (payment && payment.account && payment.account.name && payment.account.name === 'Shastha Fresh Delivery Store' ? 'Shastha Fresh' : (payment && payment.account && payment.account.name))}
                            </Col>
                        </Row>
                        <div className="mt-3 mb-3" style={{fontWeight: '400', fontSize: '13px', color: '#474747'}}>
                            <p>
                                Reference Id: {
                                (payment && payment.gid) ? (payment.gid).slice(-REFRENCE_ID_LENGTH) : <>&#8211;</>
                            }
                            </p>
                        </div>
                        {
                            tabName === 'UPI' && (
                                <>
                                    <H2Text>
                                        Amount
                                    </H2Text>
                                    <DescriptionText fontSize="24px">
                                        {payment ? `${currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency && payment.account.currency.name)}` : null}
                                    </DescriptionText>
                                </>
                            )
                        }
                    </div>
                    <div style={{position: "sticky", top: "85%"}}>
                        <Support email={payment && payment.support && payment.support.email}
                                 phone={payment && payment.support && (payment.account.gid === 'account-25729ddf59914c9abcb41a107d824330' ? '+16507435681' : payment.support.phone)}
                                 whiteLabel={payment && payment.account && payment.account.whiteLabel}
                                 partnerImageUrl={partnerImageUrl}
                                 bankImageUrl={bankImageUrl}/>
                        {agregatorName === 'EPAYMENTS' ?
                            <div style={{position: "sticky", marginLeft: "75%", bottom: "9%"}}>
                                <a href="https://www.swirepay.com" target="_blank">
                                    <img src={EPaymentImg} alt=""/>
                                </a>
                            </div>
                            :
                            agregatorName === 'OMEGAITR' ?
                                <div style={{position: "sticky", marginLeft: "75%", bottom: "9%"}}>
                                    <a href="https://www.swirepay.com" target="_blank">
                                        <img src={OMEGAITRlogo} alt=""/>
                                    </a>
                                </div>
                                :
                                ''
                        }

                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header 
                    payment={payment} 
                    bankImageUrl={bankImageUrl} 
                    tabName={tabName}
                    cancelUrlLink={null}
                />
                {payment?.account?.country?.alpha2 === 'US' ? (
                  <PaymentExpandableRowsV2
                    name={inventoryorderId}
                    id={inventoryorderId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay ={isApplePay}
                    accountGid={payment?.account?.gid}
                    supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                    account={payment?.account}
                  />) : (
                  <PaymentExpandableRows
                    name={inventoryorderId}
                    id={inventoryorderId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay={isApplePay}
                    accountGid={payment?.account?.gid}
                  />
                )}
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                <RecaptchaModal
                    visible={recaptchaModalVisible}
                    onVerified={onGlobalCaptchaVerified}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen}/>
                <SuccessModal isOpen={isTransactionSuccessModalOpen}/>
                <AlertModal
                    showIcon={alertConfig.showIcon}
                    isOpen={alertConfig.isOpen}
                    hideBtn={alertConfig.hideBtn}
                    cancel={alertConfig.cancel}
                    header={alertConfig.header}
                    body={alertConfig.body}
                    submitBtnText={alertConfig.submitBtnText}
                    cancelBtnText={alertConfig.cancelBtnText}
                    showCancelBtn={alertConfig.showCancelBtn}
                    showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon}/>
                <Spinner isOpen={isShowSpinner}/>
            </>
        }/>
    )
};

export default InventoryOrder;
